import SuccessIcon from "../../assets/images/SuccessIcon";
import { BackButton, Button } from "../../components";
import { navigateTo } from "../../helper";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

function SubmitContactService() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const ticketNumber = searchParams.get("ticket") || "";

  const handleClick = () => {
    navigateTo("/");
  };

  return (
    <div className="px-2 mt-3">
      <BackButton onClick={handleClick} text={t("Home")} />
      <div className="flex  flex-col items-center  gap-8 mt-4 px-2">
        <span className="text-xl font-semibold  text-center ">
          {t("Thank you for submitting your request")}.
        </span>
        <SuccessIcon size={98} />
        <div className="bg-[#F8F8F8] border-[#EDEDED] border p-3 flex flex-col items-center rounded-lg gap-1">
          <span className="text-[#505050] text-lg">{t("Request Number")}</span>
          <span className="font-semibold text-4xl text-[#22222C]">
            {ticketNumber}
          </span>
        </div>
        <span className="text-xl font-semibold -mt-4 text-center ">
          {t("We’ll reach out soon")}.
        </span>
        <Button onClick={handleClick} className="mt-4 rounded-lg">
          {t("Back to Home")}
        </Button>
      </div>
    </div>
  );
}

export default SubmitContactService;
